export default __webpack_public_path__ + "static/media/wbussines.68569aaa.png";